document.addEventListener("DOMContentLoaded", () => {
  // Создаем тултип и добавляем его в body
  const tooltip = document.createElement("div");
  tooltip.className = "tooltip";
  document.body.appendChild(tooltip);

  // Кнопка для закрытия тултипа
  const closeButton = document.createElement("button");
  closeButton.className = "tooltip-close";
  closeButton.textContent = "×";
  tooltip.appendChild(closeButton);

  let isHovered = false; // Флаг для отслеживания состояния курсора
  let hideTimeout;

  const tooltipContainers = document.querySelectorAll(".tooltip-container");

  const isMobileView = () => window.innerWidth < 1024;

  const showTooltip = (event) => {
    const container = event.currentTarget;
    clearTimeout(hideTimeout);
    isHovered = true;

    const tooltipContent = container.querySelector(".tooltip-content");
    if (!tooltipContent) return;

    tooltip.innerHTML = tooltipContent.innerHTML;
    tooltip.appendChild(closeButton); // Добавляем кнопку закрытия
    tooltip.style.display = "block";

    if (isMobileView()) {
      tooltip.style.top = "50%";
      tooltip.style.left = "50%";
      tooltip.style.transform = "translate(-50%, -50%)";
      tooltip.classList.add("tooltip-center");
    } else {
      tooltip.classList.remove("tooltip-center");
      const containerRect = container.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();
      const margin = 20; // Отступ между элементом и тултипом

      let top, left, positionClass;

      const calculateTooltipPosition = () => {
        const scrollX = window.scrollX;
        const scrollY = window.scrollY;

        if (containerRect.top + scrollY - tooltipRect.height - margin > 0) {
          top = containerRect.top + scrollY - tooltipRect.height - margin;
          left =
            containerRect.left +
            scrollX +
            containerRect.width / 2 -
            tooltipRect.width / 2;
          positionClass = "tooltip-top";
        } else if (
          containerRect.bottom + scrollY + tooltipRect.height + margin <
          window.innerHeight + scrollY
        ) {
          top = containerRect.bottom + scrollY + margin;
          left =
            containerRect.left +
            scrollX +
            containerRect.width / 2 -
            tooltipRect.width / 2;
          positionClass = "tooltip-bottom";
        } else if (
          containerRect.left + scrollX - tooltipRect.width - margin >
          0
        ) {
          top =
            containerRect.top +
            scrollY +
            containerRect.height / 2 -
            tooltipRect.height / 2;
          left = containerRect.left + scrollX - tooltipRect.width - margin;
          positionClass = "tooltip-left";
        } else {
          top =
            containerRect.top +
            scrollY +
            containerRect.height / 2 -
            tooltipRect.height / 2;
          left = containerRect.right + scrollX + margin;
          positionClass = "tooltip-right";
        }
      };

      calculateTooltipPosition();
      tooltip.classList.remove(
        "tooltip-top",
        "tooltip-bottom",
        "tooltip-left",
        "tooltip-right"
      );
      tooltip.classList.add(positionClass);
      tooltip.style.top = `${top}px`;
      tooltip.style.left = `${left}px`;
    }
  };

  const hideTooltip = () => {
    isHovered = false;
    hideTimeout = setTimeout(() => {
      if (!isHovered) {
        tooltip.style.display = "none";
        tooltip.innerHTML = ""; // Очищаем контент тултипа
      }
    }, 200);
  };

  const updateEventListeners = () => {
    tooltipContainers.forEach((container) => {
      const isIgnored = container.classList.contains("ignore-tooltip");

      container.removeEventListener("click", showTooltip);
      container.removeEventListener("mouseenter", showTooltip);
      container.removeEventListener("mouseleave", hideTooltip);

      if (isMobileView() && isIgnored) {
        // На мобильных устройствах тултип отключен для ignore-tooltip
        return;
      }

      if (isMobileView()) {
        container.addEventListener("click", showTooltip);
      } else {
        container.addEventListener("mouseenter", showTooltip);
        container.addEventListener("mouseleave", hideTooltip);
      }
    });
  };

  updateEventListeners();

  window.addEventListener("resize", updateEventListeners);

  tooltip.addEventListener("mouseenter", () => {
    isHovered = true;
    clearTimeout(hideTimeout);
  });

  tooltip.addEventListener("mouseleave", hideTooltip);

  closeButton.addEventListener("click", () => {
    tooltip.style.display = "none";
    tooltip.innerHTML = ""; // Очищаем контент тултипа
  });
});
